import { Box, Button, Center, Container, Flex, Heading, Icon, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr } from '@chakra-ui/react';
import { useEffect } from 'react';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import { MdOutlineClose } from 'react-icons/md';
import { PiClockCounterClockwiseBold } from 'react-icons/pi';
import { RiCloseCircleFill } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ModalLoading from '../../components/Loader/ModalLoader';
import { trackPurchase } from '../../helper/utils/eventTrackGA';
import { urlNavigate } from '../../helper/utils/navigation';
import { doGetOrderById } from '../../redux/waiver/waiver.actions';
import { formatPrice } from '../membership/cart/PriceTag';

const SuccessPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { loading, orderDetail } = useSelector((state) => state?.waiver || {}) || {};
    const [params, _] = useSearchParams();

    const orderId = params.get('order_id') || '';

    const handleGetOrder = () => {
        dispatch(doGetOrderById({ orderId }));
    };

    useEffect(() => {
        if (orderId != '') {
            handleGetOrder();
        }
    }, [orderId]);

    const paymentHistory = (orderDetail['settlement'] || {})['paymentHistory'] || [];
    const payment = paymentHistory.length > 0 ? paymentHistory[0] : {};
    const pendingPayment = payment['order_status'] === 'pending';
    const successPayment = payment['order_status'] === 'capture' || payment['order_status'] === 'settlement' || payment['order_status'] === 'success';

    const color = pendingPayment ? 'orange' : successPayment ? 'green' : 'red';

    useEffect(() => {
        trackPurchase({
            payment_status: payment['order_status'],
            transaction_id: payment['trx_id'],
            payment_type: payment['payment_type'],
            order_amount: payment['order_amount'],
        });
    }, [payment]);

    return (
        <Box w='full' h='100vh' p={3} bg={`${color}.50`}>
            <ModalLoading loading={loading} />

            <Center w='full' h='100vh'>
                <Container maxW='4xl' bg='white' rounded='2xl' border='2px' borderColor={`${color}.100`} px={5} py={12} centerContent>
                    <Icon as={pendingPayment ? PiClockCounterClockwiseBold : successPayment ? BsFillCheckCircleFill : RiCloseCircleFill} fontSize={{ base: '65px', md: '80px' }} color={`${color}.500`} />
                    <Heading fontSize={{ base: '2xl', md: '3xl' }} mt={3} textTransform='capitalize'>
                        {payment['order_status']} Transaction
                    </Heading>
                    {!successPayment && <Text fontSize={{ base: 'md', md: 'lg' }}>Please check your transaction.</Text>}

                    <Box my={10}>
                        {successPayment ? (
                            <Button
                                fontSize={{ base: 'sm', md: 'md' }}
                                size='lg'
                                rounded='lg'
                                py={7}
                                colorScheme='red'
                                leftIcon={<MdOutlineClose fontSize='18px' />}
                                onClick={() => {
                                    navigate(urlNavigate('online-sales', 'home'));
                                }}>
                                Close
                            </Button>
                        ) : (
                            <Flex w='full' gap={3}>
                                <Button
                                    fontSize={{ base: 'sm', md: 'md' }}
                                    size='lg'
                                    rounded='lg'
                                    py={7}
                                    variant='outline'
                                    colorScheme='gray'
                                    onClick={() => {
                                        handleGetOrder();
                                    }}>
                                    Refresh
                                </Button>
                                <Button
                                    fontSize={{ base: 'sm', md: 'md' }}
                                    size='lg'
                                    rounded='lg'
                                    py={7}
                                    colorScheme={color}
                                    onClick={() => {
                                        window.open(payment['urlPayment'], '_blank');

                                        handleGetOrder();
                                    }}>
                                    Open Transaction
                                </Button>
                            </Flex>
                        )}
                    </Box>

                    <Box w='full'>
                        <TableContainer>
                            <Table variant='simple'>
                                <Thead bg={color} color='white'>
                                    <Tr>
                                        <Th color='white'>No. </Th>
                                        <Th color='white'>Transaction Id</Th>
                                        <Th color='white'>Method</Th>
                                        <Th color='white'>Status</Th>
                                        <Th color='white'>Subtotal</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {paymentHistory?.map((data, index) => {
                                        return (
                                            <Tr key={index}>
                                                <Td>{index + 1}.</Td>
                                                <Td>{data['trx_id']}</Td>
                                                <Td textTransform='uppercase'>{data['payment_type']}</Td>
                                                <Td textTransform='uppercase' fontWeight={700} color={`${color}.600`}>
                                                    {data['order_status']}
                                                </Td>
                                                <Td>{formatPrice(data['order_amount'])}</Td>
                                            </Tr>
                                        );
                                    })}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>

                    {successPayment || (
                        <Box mt={8}>
                            <Button
                                fontSize={{ base: 'sm', md: 'md' }}
                                size='lg'
                                rounded='lg'
                                py={7}
                                colorScheme='red'
                                leftIcon={<MdOutlineClose fontSize='18px' />}
                                onClick={() => {
                                    navigate(`${urlNavigate('online-sales', 'home')}`);
                                }}>
                                Back to Home
                            </Button>
                        </Box>
                    )}
                </Container>
            </Center>
        </Box>
    );
};

export default SuccessPage;
